(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function(){
  var tip = document.createElement('div');
  tip.style.cssText = 'position:fixed;z-index:2147483647;background:#1B1B1B;color:#fff;padding:10px 14px;border-radius:6px;font-size:12px;line-height:1.4;text-align:center;max-width:260px;box-shadow:0 6px 20px rgba(0,0,0,.25);pointer-events:none;opacity:0;transition:opacity .12s;transform:translate(-50%,-100%);left:-9999px;top:-9999px;';
  document.body.appendChild(tip);
  function show(el){
    var t = el.getAttribute('data-tooltip'); if(!t) return;
    tip.textContent = t;
    var r = el.getBoundingClientRect();
    tip.style.left = (r.left + r.width/2) + 'px';
    tip.style.top = (r.top - 8) + 'px';
    tip.style.opacity = '1';
  }
  function hide(){ tip.style.opacity = '0'; }
  document.addEventListener('mouseover', function(e){
    var el = e.target.closest && e.target.closest('.lbdh-reassure__info[data-tooltip]');
    if(el) show(el);
  });
  document.addEventListener('mouseout', function(e){
    var el = e.target.closest && e.target.closest('.lbdh-reassure__info[data-tooltip]');
    if(el) hide();
  });
  document.addEventListener('focusin', function(e){
    var el = e.target.closest && e.target.closest('.lbdh-reassure__info[data-tooltip]');
    if(el) show(el);
  });
  document.addEventListener('focusout', hide);
})();

  } catch(e) { console.error(e); }
})();
})();
